module.exports = __webpack_public_path__ + "static/media/photo123.1d0eb05d.jpg";